
export const asyncOpenUrl = async (
  getUrl: () => Promise<string | null | undefined>,
  mode: '_blank' | '_self' = '_blank',
) => {
  if (mode === '_self') {
    const url = await getUrl();
    if (url) {
      window.location.href = url;
    }
  } else if (mode === '_blank') {
    const windowReference = window.open('', '_blank');
    if (!windowReference) {
      return;
    }

    try {
      const url = await getUrl();
      if (url) {
        windowReference.location = url;
      } else {
        windowReference.close();
      }
    } catch (e) {
      windowReference.close();
    }
  }
}
